import { PaymentOption } from '@/modules/checkout/_core/domain/entities'
import {
  clearReturnFromAppCdt,
  hasReturnedFromAppCdt,
} from '@/modules/checkout/utils/appDeepLink'
import { MixpanelTracker } from '@/shared/libs/mixpanel/MixpanelTracker'
import { getDeviceType } from '@/shared/utils/get-device-type'

export class PaymentFlowAnalytics {
  public static onClickSeeDetails = (newValue: string) => {
    if (!newValue) {
      return MixpanelTracker.sendEvent('LINK-pagto_cliente_esconder_detalhes')
    }
    return MixpanelTracker.sendEvent('LINK-pagto_cliente_ver_detalhes')
  }

  public static onAccessLink = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_acessar_link')
  }

  public static onClickSeeTerms = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_termos_de_uso')
  }

  public static onClickPaymentType = (type: string) => {
    if (type === PaymentOption.CreditCard) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_cartao')
    }
    if (type === PaymentOption.Pix) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_pix')
    }
    if (type === PaymentOption.BankSlip) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_boleto')
    }
  }

  public static onClickCardType = (cardType: string) => {
    if (cardType === PaymentOption.CreditCard) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_crédito')
    }
    if (cardType === PaymentOption.DebitCard) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_débito')
    }
  }

  public static onClickPixType = (pixType: string) => {
    if (pixType === PaymentOption.AutomaticPixCopyPaste) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_pix_automatico')
    }
    if (pixType === PaymentOption.Pix) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_pix_avulso')
    }
  }

  public static onClickInstallments = (installments: string) => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_parcelas', {
      installments,
    })
  }

  public static onClickPayment = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_selecionar_pagar')
  }

  public static onClickCopyCode = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_copiar_codigo')
  }

  public static onClickPrint = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_imprimir_comprovante')
  }

  public static onApprovedPayment = (type: PaymentOption, linkId?: string) => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_pagto_aprovado')

    if (type === PaymentOption.Pix) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_aprovado_pix')
    }

    if (type === PaymentOption.AutomaticPixCopyPaste) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_aprovado_pix_automatico')
    }

    if (type === PaymentOption.BankSlip) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_aprovado_boleto')
    }

    if ([PaymentOption.CreditCard, PaymentOption.DebitCard].includes(type)) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_aprovado_cartao')
    }

    if (!linkId || !hasReturnedFromAppCdt(linkId)) return

    MixpanelTracker.sendEvent('LINK-pagto_cliente_retorno_web_pagto_aprovado')

    if (
      [PaymentOption.Pix, PaymentOption.AutomaticPixCopyPaste].includes(type)
    ) {
      MixpanelTracker.sendEvent('LINK-pagto_cliente_retorno_web_aprovado_pix')
    }

    if ([PaymentOption.CreditCard, PaymentOption.DebitCard].includes(type)) {
      MixpanelTracker.sendEvent(
        'LINK-pagto_cliente_retorno_web_aprovado_cartao',
      )
    }
  }

  public static onWebReceipt = (linkId: string) => {
    if (!hasReturnedFromAppCdt(linkId)) return

    MixpanelTracker.sendEvent('LINK-pagto_cliente_retorno_web_comprovante_web')
    clearReturnFromAppCdt(linkId)
  }

  public static onAppRedirectAttempt = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_abrir_app')
  }

  public static onAppRedirectFallback = () => {
    MixpanelTracker.sendEvent('LINK-pagto_cliente_abrir_app_indisponivel')
  }

  public static registerPaymentProperties = (
    uuid?: string,
    mainSeller?: string,
    redirectToAppCdt?: boolean,
  ) => {
    MixpanelTracker.registerGlobalProperty({
      uuid,
      mainSeller: mainSeller ?? null,
      device_type: getDeviceType(),
      redirect_to_app_cdt: Boolean(redirectToAppCdt),
      app_cdt_flag: null,
    })
  }

  public static registerAppCdtFlag = (isEnabled: boolean) => {
    MixpanelTracker.registerGlobalProperty({
      app_cdt_flag: isEnabled,
    })
  }
}
